export default __webpack_public_path__ + "static/media/avatar-9.d011667d.png";